<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div style="overflow-x: hidden">
    <v-dialog v-model="delDialog" max-width="640px" class="pa-2">
      <v-card v-if="currentItem!=null">
        <v-card-title class="headline">Datei löschen</v-card-title>
        <v-card-text>Möchten Sie die Datei <br>"{{currentItem.filename}}" <br>wirklich löschen?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="delDialog = false">Abbrechen</v-btn>
          <v-btn color="red darken-1" flat @click="deleteFile()">Datei löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" fullscreen class="pa-2">
      <v-card v-if="currentItem!=null" style="overflow: hidden;height: 100%;">
        <v-card-title class="headline textgrey">
            Ihr Dokument
            <v-btn icon @click="closeDialog()" style="position: absolute;right: 10px;">
              <v-icon color="#6f6f6e">close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
          <MyPDFViewer id="dlgContainer" ref="pdfViewer" :jobs="jobs"></MyPDFViewer>
        </v-card-text>
        <v-card-actions>
          <v-btn outline dark color="#bc460d" v-if="!isNewFile" @click="showDeleteDialog"
                 class="text-none my-3">
            Dokument löschen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn block outline dark color="#5f6da9" v-if="!isNewFile" @click="downloadFile()"
                 class="text-none my-3">
            {{'BTN_DOWNLOAD' | translate}}
            <!--<v-icon right dark>cloud_download</v-icon>-->
          </v-btn>
          <v-btn block outline dark color="#5f6da9" v-if="!isNewFile" @click="printFile()" class="text-none my-3">
            {{'BTN_PRINT' | translate}}
            <!--<v-icon right dark>print</v-icon>-->
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import sas from 'surfandscan'
// import $ from 'jquery'
import MyPDFViewer from '../../widgets/MyPDFViewer'
var _ = require('lodash')

export default {
  name: 'FileDialog',
  components: {MyPDFViewer},
  props: {
  },
  data () {
    return {
      pdfStyle: 'overflow: auto',
      url: null,
      documentError: null,
      taskId: null,
      pageOrder: null,
      categories: null,
      rotateArr: null,
      currentPageNumber: 1,
      currentPage: null,
      pdf: null,
      renderTask: null,
      pageCnt: 0,
      isNewFile: false,
      delDialog: false,
      menu: false,
      date: '',
      jobs: [],
      dateObj: new Date(),
      datePS: '',
      dialog: false,
      catStatusByGuid: [],
      statusList: [],
      currentItem: null,
      isLoading: false,
      currentStatus: null,
      extraFieldsKey: 0
    }
  },
  methods: {
    printFile: function () {
      var blobUrl = sas.gbl_host + '/storage/item?method=PRINT&type=files&guid=' + this.currentItem.guid
      if (this.isNewFile) {
        blobUrl = sas.getDownloadTaskAsPDFURL(this.taskId, '', this.pageOrder, this.rotateArr)
      }
      console.log('print file', blobUrl)

      this.printTriggerfunction(blobUrl)
      /*
      var divToPrint = document.getElementById("printTable")
      let newWin = window.open('')
      const embed = document.createElement('embed')
      embed.type= 'application/pdf'
      embed.src = blobUrl
      embed.id = 'pdf'
      // newWin.document.write(divToPrint.outerHTML)
      newWin.document.body.appendChild(embed)
      window.setTimeout(function () {
        newWin.print()
        newWin.close()
      }, 4000)
       */
    },
    showDeleteDialog: function () {
      console.log('delDialog')
      this.delDialog = true
    },
    downloadFile: function () {
      console.log('download file')
      Vue.prototype.$dms.downloadStorageItem(this.currentItem.guid, this.currentItem.filename, this.onGetFileDone)
    },
    onUpdateDone: function (data) {
      console.log('onUpdateDone', data)
      this.extraFieldsKey++
      Vue.prototype.$eventHub.$emit('filespoolchanged')
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.isLoading = false
      this.hasError = true
      this.errorText = JSON.stringify(error)
    },
    printTriggerfunction: function (url) {
      console.log('printTriggerfunction', url)
      var iframe = this._printIframe
      if (!this._printIframe) {
        iframe = this._printIframe = document.createElement('iframe')
        document.body.appendChild(iframe)
        iframe.src = url
        // iframe.style.display = 'none';
        iframe.onload = function () {
          setTimeout(function () {
            iframe.focus()
            iframe.contentWindow.print()
          }, 1)
        }
      }
      iframe.src = url
    },
    doPrinting: function (id) {
      var that = this
      var pId = id
      var pdfObject = document.getElementById(id)
      if (typeof (pdfObject.print) === 'undefined') {
        setTimeout(function () {
          that.doPrinting(pId)
        }, 1000)
      } else {
        pdfObject.print()
      }
    },
    closeDialog: function () {
      console.log('close dialog')
      let cmp = this // dlgContainer
      this.$refs['pdfViewer'].close()
      this.$nextTick(function () {
        cmp.dialog = false
        this.$eventHub.$emit('OnShowIdle', false)
        cmp.$emit('close', {})
      })
    },
    deleteFile: function () {
      console.log('delete file')
      Vue.prototype.$dms.deleteFileFromStorage(this.currentItem.guid, this.onDeleteFileDone)
    },
    onChangeItemCategory: function (item) {
      console.log('onChangeItemCategory', item)
      this.saveItem()
    },
    onDeleteFileDone: function () {
      console.log('onDeleteFileDone')
      this.delDialog = false
      this.dialog = false
      this.$eventHub.$emit('OnShowIdle', false)
      Vue.prototype.$eventHub.$emit('filespoolchanged')
    },
    onGetFileDone: function () {
      console.log('onGetFileDone')
      this.$eventHub.$emit('OnShowIdle', false)
    },
    getExtraFields: function (cat) {
      let category = Vue.prototype.$storage.getCategoriesObjectGuidList()[cat.guid]
      let fieldArray = []
      if (!category) return fieldArray
      if (!category.extraFields) return fieldArray
      for (const [key, value] of Object.entries(category.extraFields)) {
        if (key) {
          fieldArray.push(value)
        }
      }
      return fieldArray
    },
    onDocumentErrored (e) {
      this.documentError = e.text
    },
    removeCategory: function (item) {
      var index = this.currentItem.listCategories.indexOf(item)
      if (index > -1) {
        this.currentItem.listCategories.splice(index, 1)
      }
      this.saveItem()
    },
    onChangeStatus (f) {
      console.log('onChangeStatus', f)
      this.saveItem()
    },
    openAsNewFile (fileItem, taskId, pageOrder, rotateArr) {
      let cmp = this
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
      this.isNewFile = true
      this.taskId = taskId
      this.pageOrder = pageOrder
      this.rotateArr = rotateArr
      this.currentItem = fileItem
      this.dialog = true
      var d = new Date(this.currentItem.targetDate)
      this.dateObj = d
      this.datePS = this.dateObj.toISOString().substr(0, 10)
      this.date = d.toLocaleDateString('de-DE')
      this.$nextTick(function () {
        cmp.$refs['pdfViewer'].open(cmp.currentItem)
      })
    },
    updateValuesAutomatically () {
      this.currentItem.listCategories = []
      for (var i in this.categories) {
        var cat = this.categories[i]
        if (cat.categorySelectWord && cat.categorySelectWord.length > 0 && this.currentItem.rawText) {
          let index = this.currentItem.rawText.toLowerCase().indexOf(cat.categorySelectWord.toLowerCase())
          if (index > -1) {
            this.currentItem.listCategories.push(cat)
          }
        }
      }
      this.extraFieldsKey++
    },
    updateTimeInGui (myTime) {
      var d = new Date(myTime)
      this.dateObj = d
      console.log('myTime', myTime, d)
      this.datePS = this.dateObj.toISOString().substr(0, 10)
      this.date = d.toLocaleDateString('de-DE')
    },
    onGetJobs (jobs) {
      console.log('onGetJobs', jobs)
      if (jobs) {
        this.jobs = jobs.jobs
        if (this.$refs.pdfViewer && this.$refs.pdfViewer.checkJobs) {
          this.$refs.pdfViewer.checkJobs()
        }
        if (this.jobs.length > 0) {
          let cmp = this
          window.setTimeout(function () {
            cmp.reloadJobs()
          }, 5000)
        }
      }
    },
    reloadJobs () {
      Vue.prototype.$dms.getJobsOfItem(this.currentItem.sid, this.onGetJobs)
    },
    onGetDetailData (res) {
      this.currentStatus = null
      if (res && res.files && res.files.length > 0) {
        console.log('onGetDetailData', res.files[0])
        this.currentItem = this.prepareItem(res.files[0])
      }
      if (this.currentItem && this.currentItem.status) {
        let index = _.findIndex(this.statusList, ['guid', this.currentItem.status[0]])
        if (index > -1) {
          this.currentStatus = this.statusList[index]
        }
      }
      this.reloadJobs()
      this.updateTimeInGui(this.currentItem.time)
      this.$eventHub.$emit('OnShowIdle', false)
      let cmp = this
      this.$nextTick(function () {
        cmp.$refs['pdfViewer'].open(cmp.currentItem)
      })
    },
    prepareItem (item) {
      var selectedItem = item
      selectedItem.listCategories = []
      selectedItem.targetDate = new Date(selectedItem.time).toISOString().substr(0, 10)
      for (var i in item.categories) {
        var catGuid = item.categories[i]
        selectedItem.listCategories.push(this.catObjectsByGuid[catGuid])
      }
      selectedItem = Vue.prototype.$storage.checkExtraFieldStatus(selectedItem)

      return selectedItem
    },
    open (fileItem) {
      let cmp = this
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
      this.catStatusByGuid = Vue.prototype.$storage.getStatusObjectGuidList()
      this.statusList = Vue.prototype.$storage.getStatusList()
      this.isNewFile = false
      this.dialog = true
      if (this.isNewFile) {
        this.currentItem = this.prepareItem(fileItem)
        this.updateTimeInGui(this.currentItem.targetDate)
        this.$nextTick(function () {
          cmp.$refs['pdfViewer'].open(cmp.currentItem)
        })
        this.updateValuesAutomatically()
      } else {
        let reqData = {
          guid: fileItem.guid
        }
        this.$eventHub.$emit('OnShowIdle', true)
        Vue.prototype.$dms.searchStorage(reqData, this.onGetDetailData)
      }
    }
  },
  watch: {
    dialog (dialog, oldDialog) {
      if (!dialog) {
        this.$eventHub.$emit('OnShowIdle', false)
      }
    },
    currentPage (page, oldPage) {
      // this.destroyPage(oldPage)
    }
  },

  mounted () {
    Vue.prototype.scanApi.updateUrl(sas)
    this.isLoading = true
    // Vue.prototype.scanApi.getCategories(this.onGetCategories)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/dialogs/FileDialog.vue